import { render, staticRenderFns } from "./Zjzsdy.vue?vue&type=template&id=c81eb18a"
import script from "./Zjzsdy.vue?vue&type=script&lang=js"
export * from "./Zjzsdy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports